import { useEffect } from "react";
import AccountTypes from "../components/Accounts/AccountTypes";
import Cards from "../components/Accounts/Cards";
import NeedHelp from "../components/Accounts/NeedHelp";

function Accounts() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <AccountTypes />
            <Cards />
            <NeedHelp />
        </div>
    );
}

export default Accounts;
